import ActionTypes from 'app/opensource/ActionTypes';
import routes from 'app/opensource/routes';

export default {
  actionTypes: ActionTypes,
  routes,
};
